// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'arrow-bend-left';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='m8.438 5.625 2.25-2.25-2.25-2.25m7.289 8.438a6.732 6.732 0 0 1-.19 2.25M14.17 5.786c.367.436.677.916.922 1.43m-.938 7.268a6.738 6.738 0 0 1-1.725 1.457' />
    <path d='M9.563 16.852A6.75 6.75 0 1 1 9 3.375h1.688' />
  </g>
);

export const viewBox = '0 0 18 18';
